import React, { useState } from 'react'
import { useResearcherSDGReport } from '../../../hooks/rs/useResearcherSDGReport'
import {
  Card,
  CloseButton,
  Col,
  Container,
  ListGroup,
  Row,
} from 'react-bootstrap'
import { t } from '../../../localization/localization'
import icons from '../../../data/sdg_icons'
import RosetteResearher from '../../../components/rosetteResearcher'

const colors = [
  '#E5243B',
  '#DDA83A',
  '#4C9F38',
  '#C5192D',
  '#FF3A21',
  '#26BDE2',
  '#FCC30B',
  '#A21942',
  '#FD6925',
  '#DD1367',
  '#FD9D24',
  '#BF8B2E',
  '#3F7E44',
  '#0A97D9',
  '#56C02B',
  '#00689D',
  '#19486A',
]

const SdgOverlay = ({ idx, publications, children }) => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const locale = urlSearchParams.get('locale') ?? 'tr'

  const [show, setShow] = useState(false)
  const handleToggle = () => {
    setShow(!show)
  }

  return (
    <div
      style={{
        cursor: 'pointer',
      }}
      onMouseEnter={handleToggle}
      onMouseLeave={handleToggle}
      className="position-relative inline-block"
    >
      {children}
      {show && (
        <div
          className="position-absolute left-0 bg-white rounded-sm"
          style={{
            minWidth: '200px',
            zIndex: '1000',
          }}
        >
          <Card className="text-center">
            <Card.Header className="col-12 font-bold m-0">
              <span className="text-center">
                {t(locale, '/rs/profile/tab/publications')}
              </span>
            </Card.Header>
            <Card.Body>
              <ListGroup
                style={{
                  maxHeight: '300px',
                  overflow: 'auto',
                }}
              >
                {publications.map((publication, publicationIdx) => (
                  <a
                    style={{
                      color: colors[idx],
                    }}
                    target="_blank"
                    href={`${publication.url}`}
                  >
                    <ListGroup.Item
                      action
                      variant="light"
                      key={`publication-${publicationIdx}`}
                    >
                      {publication.name}
                    </ListGroup.Item>
                  </a>
                ))}
              </ListGroup>
            </Card.Body>
          </Card>
        </div>
      )}
    </div>
  )
}

const SdgRosettes = ({ crisId }) => {
  const { data: sdgReport, isSuccess } = useResearcherSDGReport(crisId)
  const urlSearchParams = new URLSearchParams(window.location.search)
  const locale = urlSearchParams.get('locale') ?? 'tr'

  return (
    <>
      {isSuccess && sdgReport.some((sdg) => sdg.count > 0) && (
        <Container fluid>
          <Row className="wall">
            <Col>
              <h4 className="text-capitalize">
                {t(locale, '/rs/rosettes/sdg-report')}
              </h4>
              <Row>
                {sdgReport.map((sdg, idx) => {
                  if (sdg.count > 0) {
                    return (
                      <Col
                        className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3"
                        key={idx}
                      >
                        <SdgOverlay idx={idx} publications={sdg.publications}>
                          <RosetteResearher
                            hoverable
                            color={colors[idx]}
                            icon={icons[idx]}
                            text={t(locale, `/rosettes/${sdg.name}`)}
                            countTitle={t(locale, '/rosettes/researchProducts')}
                            count={sdg.count}
                            idx={idx}
                          />
                        </SdgOverlay>
                      </Col>
                    )
                  }
                })}
              </Row>
            </Col>
          </Row>
        </Container>
      )}
    </>
  )
}

export default SdgRosettes
